import { get, post, put, del, getXml } from "./utils";

// GET /merchants
export const fetchMerchants = (q) => get("merchants", { q });
// GET /merchants/:merchant_id
export const fetchMerchant = (merchant_id) => get(`merchants/${merchant_id}`);
// GET /merchants/:merchant_id/reports
export const fetchReports = (merchant_id) =>
  get(`merchants/${merchant_id}/reports`);
// GET /merchants/:merchant_id/reports/schema
export const fetchSchema = (merchant_id) =>
  get(`merchants/${merchant_id}/reports/schema`);
// POST /merchants/:merchant_id/reports
export const createReport = (merchant_id, report) =>
  post(`merchants/${merchant_id}/reports`, { report });
// GET /merchants/:merchant_id/reports/:report_id
export const readReport = (merchant_id, report_id) =>
  get(`merchants/${merchant_id}/reports/${report_id}`);
// PUT /merchants/:merchant_id/reports/:report_id
export const updateReport = (merchant_id, report_id, report) =>
  put(`merchants/${merchant_id}/reports/${report_id}`, { report });
// DELETE /merchants/:merchant_id/reports/:report_id
export const deleteReport = (merchant_id, report_id) =>
  del(`merchants/${merchant_id}/reports/${report_id}`);
// GET /merchants/:merchant_id/report/:report_id/report_files/:id/download
export const downloadReport = (merchant_id, report_id, report_file_id) =>
  get(
    `merchants/${merchant_id}/reports/${report_id}/report_files/${report_file_id}/download`
  );
// PUT /merchants/:merchant_id/report/:report_id/report_files/:id/send_latest
export const sendLatestReport = (merchant_id, report_id) =>
  put(`merchants/${merchant_id}/reports/${report_id}/send_latest`);

export const fetchFailedReportStatuses = () => get(`admin/failures`);
// PUT /merchants/:merchant_id/reports/:report_id/files/:file_id/resend
export const resendReport = (merchant_id, report_id, report_file_id, process) =>
  put(
    `merchants/${merchant_id}/reports/${report_id}/files/${report_file_id}/resend`,
    { process }
  );

export const regenerateReport = (report_file_id) =>
  get(`admin/regen`, { report_file_id });

export const regenerateSystemFailures = () => get(`admin/recover`);

export const fetchFiles = (merchant_id) =>
  get(`merchants/${merchant_id}/report_files`);

// GET /login
export const login = () => get(`login`);
// GET /logout
// http verb should be delete here
export const logout = () => get(`logout`);

// GET /maintenance_banner
export const fetchMaintenanceBanner = () => get(`maintenance_banner`);

//GET /analytics
// PUT /analytics/overall_metrics# param list: flyer_run_ids[], start_date, end_date, metrics[]
// NOTE: in order to pass parameters as a JSON body, we'll  need to use a PUT request
export const overall_metrics = (request) =>
  put("analytics/overall_metrics", request);

export const flyer_metric_visualization_data = (request) =>
  put("analytics/flyer_metrics", request);

export const item_metric_visualization_data = (request) =>
  put("analytics/item_metrics", request);

export const fetchToplineMetrics = (request) =>
  put("analytics/top_line_metrics", request);

export const fetchPublications = (request) =>
  put("analytics/flyer_runs", request);

export const flyer_spend_data = (request) =>
  put("analytics/spend_metrics", request);

export const fetchAnalyticsMerchants = (q) => get("analytics/merchants", { q });

// Content View
export const fetchFlyers = (flyerRunIds) =>
  put("analytics/flyers", { flyer_run_ids: flyerRunIds });

export const fetchFlyerItems = (
  flyer_id,
  metrics,
  start_date,
  end_date,
  filters,
  group_by
) =>
  put("analytics/flyer_items", {
    flyer_id,
    metrics,
    start_date,
    end_date,
    filters,
    group_by
  });

// Data Export
export const fetchReachReport = (flyerRunIds, startDate, endDate) =>
  put("analytics/export/reach", {
    flyer_run_ids: flyerRunIds,
    start_date: startDate,
    end_date: endDate
  });

export const fetchAudienceReport = (flyerRunIds, startDate, endDate) =>
  put("analytics/export/audience", {
    flyer_run_ids: flyerRunIds,
    start_date: startDate,
    end_date: endDate
  });

export const fetchFinanceReport = (flyerRunIds, startDate, endDate) =>
  put("analytics/export/finance", {
    flyer_run_ids: flyerRunIds,
    start_date: startDate,
    end_date: endDate
  });

export const fetchContentPublicationReport = (flyerRunId, startDate, endDate) =>
  put("analytics/export/content/publication", {
    flyer_run_ids: [flyerRunId],
    start_date: startDate,
    end_date: endDate
  });

export const fetchContentVersionReport = (flyerId, startDate, endDate) =>
  put("analytics/export/content/version", {
    flyer_id: flyerId,
    start_date: startDate,
    end_date: endDate
  });

//GET store visits
export const fetchStoreVisitsPublications = (request) =>
  put("store_visits/flyer_runs", request);

export const fetchStoreVisitsMerchants = (q) =>
  get("store_visits/merchants", { q });

export const fetchStoreVisitsTopStoresData = (request) =>
  put("store_visits/top_stores", request);

export const fetchSFML = (url) => getXml(url);



// WEBPACK FOOTER //
// ./client/apis/index.js